import {useCallback} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {getInstitutionAccounts, getAccountTransactions} from '../actions/transactionActions';
import utils from '../helpers/utils';
import _get from 'lodash/get';
import dateUtils from '../helpers/dateUtils';
import {RootState} from '../reducers/rootReducer';
import {hasAvailableInstitution} from '../helpers/transactionHelper';
import {TXM_DEFAULT_LOOK_BACK, TXM_DEFAULT_LOOK_BACK_JP} from '../constants/durations';

/**
 * Custom hook to handle transaction data fetching
 * @returns Transaction data methods
 */
export const useTransactions = () => {
  const dispatch = useDispatch();
  const auth = useSelector((store: RootState) => store.auth);
  const accountId = _get(auth, 'user.primaryMember.accountId', '');

  /**
   * Fetches the Txm data.
   */
  const fetchTxmData = useCallback(async() => {
    const productFeatures = _get(auth, 'user.primaryMember.plan.productFeatures', null);
    const whiteLabelClient = _get(auth, 'whiteLabelClient', '');
    const showTxmUpgrade = utils.isTxmUpgradeScenario(productFeatures, whiteLabelClient);
    const primaryMember = _get(auth, 'user.primaryMember', null);

    const isUnifiedTransactionsEnabled =
      utils.isFeaturePresent(productFeatures, 'financialMonitoringUk') ||
      utils.isFeaturePresent(productFeatures, 'transactionMonitoring') ||
      utils.isFeaturePresent(productFeatures, 'fwMultiAggregator');

    if (!showTxmUpgrade && utils.showTransactions(primaryMember) && !isUnifiedTransactionsEnabled) {
      const defaultLookBack = utils.isTxmJpAvailable(productFeatures)
        ? TXM_DEFAULT_LOOK_BACK_JP
        : TXM_DEFAULT_LOOK_BACK;
      const transactionArgs = {
        startDate: dateUtils.getStartDate(defaultLookBack),
        endDate: dateUtils.getEndDate(),
        sortField: 'postedDate',
        institutionId: '',
        accountId: '',
        offset: '',
        sortOrder: '',
        memberId: '',
        rowsToRetrieve: '',
      };

      const response = await dispatch(getInstitutionAccounts({}, accountId) as any);
      if (hasAvailableInstitution(response)) {
        return await dispatch(getAccountTransactions(transactionArgs, accountId));
      }
    }
  }, [auth, dispatch, accountId]);

  return {
    fetchTxmData,
  };
};
